import { Button } from "antd";
const Eligibility = ({ loan }) => {
  const handlePrint = () => {
    const receiptContent = document.getElementById("receipt").innerHTML;
    const printWindow = window.open("", "", "width=800,height=600");
    printWindow.document.write(`
          <html>
            <head>
              <title>${loan.client_name}</title>
              <link rel="stylesheet" href="${window.location.origin}/src/pages/styles.css" />
              <style>
                /* Add any inline styles here for printing purposes */
                body {
                  font-family: Arial, sans-serif;
                  margin: 20px;
                }
                .receipt {
                  width: 100%;
                }
                @media print {
                #printButton {
                  display: none;
                }
              }
              </style>
            </head>
            <body>
              ${receiptContent}
            </body>
          </html>
        `);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };

  if (!loan.client_name) {
    return (
      <div className="callout callout-info">
        <h4 style={{ color: "white" }}>Eligibility</h4>
        <p>Eligibility report will appear here after form submission.</p>
      </div>
    );
  }
  return (
    <div id="receipt" className="receipt">
      <div className="receipt-header">
        <img
          src="/dist/img/draw3.svg"
          alt="Logo"
          className="logo"
          style={{ height: "60px" }}
        />
        <h3 style={{ marginTop: "10px" }}>Loan Eligibility</h3>
      </div>
      <div className="receipt-requirements">
        <h4>Requirements:</h4>
        <ul>
          <li>National Registration Card (Original NRC)</li>
          <li>Pre-approval form (Signed & Stamped by GRZ Representation)</li>
          <li>3 Months Latest Payslips</li>
          <li>3 Months Bank Statements</li>
        </ul>
      </div>
      <div className="receipt-details">
        <div className="row">
          <div className="col-md-6">
            <p>
              <strong>{loan.client_name}</strong>
            </p>
          </div>
          <div className="col-md-6 text-right receipt-decision">
            {loan.decision === "Approved" ? (
              <>
                <span style={{ marginRight: "3px" }} className="text-green">
                  Eligible
                </span>
                <i
                  className="fa fa-check-circle text-green"
                  aria-label="Approved"
                ></i>
              </>
            ) : (
              <>
                <span style={{ marginRight: "3px" }} className="text-red">
                  Not Eligible
                </span>
                <i
                  style={{ marginLeft: "3px" }}
                  className="fa fa-times-circle text-red"
                  aria-label="Rejected"
                ></i>
              </>
            )}
          </div>
        </div>

        <table className="receipt-table">
          <tbody>
            <tr>
              <td>Amount (K3,000-K50,000)</td>
              <td>
                {parseFloat(loan.loan_amount).toLocaleString("en-ZM", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </td>
            </tr>
            <tr>
              <td>Tenure (1-60 Months)</td>
              <td>{loan.tenure}</td>
            </tr>
            <tr>
              <td>Interest (20% + 6.5% per Month)</td>
              <td>
                {parseFloat(loan.interest).toLocaleString("en-ZM", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </td>
            </tr>
            <tr>
              <td>Processing Fee</td>
              <td>
                {parseFloat(loan.processing_fee).toLocaleString("en-ZM", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </td>
            </tr>
            <tr>
              <td>Amount Received</td>
              <td>
                {parseFloat(loan.amount_received).toLocaleString("en-ZM", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </td>
            </tr>
            <tr>
              <td>Monthly Repayment</td>
              <td>
                {parseFloat(loan.monthly_repayment).toLocaleString("en-ZM", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </td>
            </tr>
            <tr>
              <td>Total Loan</td>
              <td>
                {parseFloat(loan.total_loan).toLocaleString("en-ZM", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </td>
            </tr>
            {/* <tr>
                  <td>Decision</td>
                  <td>{loan.decision}</td>
                </tr> */}
          </tbody>
        </table>
      </div>
      <div className="receipt-footer">
        <Button
          id="printButton"
          onClick={handlePrint}
          type="primary"
          style={{ marginTop: "20px" }}
        >
          Print
        </Button>
      </div>
    </div>
  );
};

export default Eligibility;
